import { BrandCorrelationSummary } from "@/components/shared/BrandCorrelationSummary";

export function DashboardCorrelationChart() {
  return (
    <BrandCorrelationSummary
      selectedDays={30}
      cardClassName="rounded-lg border bg-card"
      showMetricCards={false}
    />
  );
}
